import React, { useEffect, useState } from "react";
import { ONDC_DEFAULT_NEW_DATA } from "../../utils/data/defaultFormData";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  extractNameCodePairs,
  extractNames,
  getDefaultProductDetailsTable,
  getOptionsForDependentCode,
  getProductCodeLength,
  getSelectedCountryByCode,
  updateMainProperty,
} from "../../utils/helper";
import {
  getReviewChildProductDetailsAPI,
  getReviewProductDetailsAPI,
  getUnitOfMeasurementApi,
  getViewChildProductDetailsAPI,
  getViewProductDetailsAPI,
} from "../../service/api_calls/catalog/CatalogAPI";
import { Box, Typography } from "@mui/material";
import { stickyHeader } from "../../utils/styles";
import { blackColor, blueColor04 } from "../../configs/styles/muiThemes";
import BreadcrumbSection from "../../components/Breadcrumb/BreadcrumbSection";
import {
  getTimeToShipUnitValue,
  getTimeToShipValue,
} from "../../utils/postDataHelpers/CatalogHelper";
import {
  getProductSubCategoryOne,
  getProductSubCategoryTwo,
} from "../../reducers/AddProduct/AddProductSlice";
import CategoryPreview from "../EditProductVariant/Preview/CategoryPreview";
import {
  getOndcFullSpecificationAPI,
  getOndcSpecificationAPI,
  getProductCodeAPI,
} from "../../service/api_calls/AddProduct/AddProductAPI";
import { PRODUCT_CODE_DEFAULT_LIST } from "../../utils/data";
import {
  mergeValidatedArrays,
  prepareCopyChildVariantProductData,
  prepareEditPreviewVariantData,
  prepareMainVariant,
  prepareVariantData,
  validateEditProductDetails,
  validateOndcSpecs,
} from "../../utils/validateAndPrepareVariant";
import AlertPopup from "../../components/Alerts/AlertPopup";
import CatalogActionBtns from "../../components/Buttons/CatalogActionBtns";
import ProductPreviewTab from "../EditProductVariant/Tabs/ProductPreviewTab";
import VariantOndcForm from "../AddProductVariant/Forms/VariantOndcForm";
import ProductVariantForm from "../EditProductVariant/Form/ProductVariantForm";
import CommonOndcForm from "../AddProductVariant/Forms/CommonOndcForm";
import ModalCard from "../../components/ModalCard";
import OndcCategoryForm from "../AddProductVariant/Forms/OndcCategoryForm";
import ProductDetailsForm from "../AddProductVariant/Forms/ProductDetailsForm";
import ThreeDotLoader from "../../components/ThreeDotLoader";
import { clearCatalogData } from "../../reducers/businessPreview/businessPreviewSlice";
import {
  addNewProductChildVariantApi,
  addNewProductVariantApi,
} from "../../service/api_calls/AddVariant/addVariantAPI";

function CopyVariantProductContent() {
  const [tab, setTab] = useState("product-details");

  const [productDetails, setProductDetails] = useState(null);

  const [productInfo, setProductInfo] = useState(null);
  const [ondcData, setOndcData] = useState(ONDC_DEFAULT_NEW_DATA);

  const [categoryInfo, setCategoryInfo] = useState(null);
  const [selectedVariant, setSelectedVariant] = useState(null);

  const [tableHeader1, setTableHeader1] = useState(null);
  const [tableHeader2, setTableHeader2] = useState(null);
  const [variantData, setVariantData] = useState(null);

  const [ondcSpecificationData, setOndcSpecificationData] = useState([]);

  const [deletedProductList, setDeletedProductList] = useState([]);

  const [unitOfMeasurementData, setUnitOfMeasurementData] = useState([]);
  const [productCodeList, setProductCodeList] = useState(null);

  const [pageError, setPageError] = useState("");

  const [ondcPreviewData, setOndcPreviewData] = useState(null);

  const [showAlert, setShowAlert] = useState(false);
  const [loader, setLoader] = useState(false);

  const businessName = sessionStorage.getItem("costboWEBURL");

  const [isCatalogChangeFlag, setIsCatalogChangeFlag] = useState(false);

  const links = [
    { label: "Product Catalog", to: `/${businessName}/catalog` },
    { label: "Copy Product", to: `#` },
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { countryList, countryListLoading, gstRates, allDeliveryMethod } =
    useSelector((state) => state.catalog);

  const { activeBusinessInfo, activeBusinessInfoLoader } = useSelector(
    (state) => state.businessPreview
  );

  const handleSetValue = (name, value, state, setState) => {
    if (name !== "errors") {
      setState({
        ...state,
        [name]: value,
        errors: { ...state?.errors, [name]: "" },
      });
      return;
    }
    setState({
      ...state,
      [name]: value,
    });
  };

  const handleKeyValueChange = (property, value, rootProperty, errCode) => {
    setOndcData((prevState) => ({
      ...prevState,
      [rootProperty]: { ...prevState[rootProperty], [property]: value },
      errors: prevState?.errors
        ? { ...prevState?.errors, [errCode]: "" }
        : null,
    }));
  };

  //handle table cell value change
  const handleValueChange = (key, value, index) => {
    let allVariants = [...variantData];

    const errors = { ...allVariants[index]?.errors };
    delete errors[key];

    if (key === "variant1" || key === "variant2" || key === "variant3") {
      console.log("HITTITIIT");
      allVariants[index] = {
        ...allVariants[index],
        [key]: { ...allVariants[index][key], inputValue: value },
        changed: true,
        errors: errors,
      };

      setVariantData(allVariants);

      return;
    }

    if (
      key === "photo1" ||
      key === "photo2" ||
      key === "photo3" ||
      key === "photo4"
    ) {
      allVariants[index] = {
        ...allVariants[index],
        [key]: value,
        addPhotos: [...allVariants?.[index]?.addPhotos, { key, value }],
        changed: true,
        errors: errors,
      };
    }

    if (key === "main") {
      const array = updateMainProperty(allVariants, value, index);
      setVariantData(array);
      return;
    }

    allVariants[index] = {
      ...allVariants[index],
      [key]: value,
      changed: true,
      errors: errors,
    };

    console.log("handleValueChange", allVariants[index]);
    setVariantData(allVariants);
  };

  const handleOndcSpecChange = (
    rootIndex,
    specIndex,
    value,
    selector = "inputValue"
  ) => {
    console.log("SpecListData___handleChange_rootIndex", rootIndex);
    console.log("SpecListData___handleChange_specIndex", specIndex);
    console.log("SpecListData___handleChange_value", value);
    console.log("SpecListData___handleChange_selector", selector);

    // Create a shallow copy of the products array
    const newProductList = [...variantData];

    // Create a shallow copy of the specific product object
    const updatedProduct = { ...variantData[rootIndex], changed: true };

    // Create a shallow copy of the specList array within the product
    const updatedSpecList = [...updatedProduct.specList];

    // Update the inputValue of the specified specIndex in the updatedSpecList
    updatedSpecList[specIndex] = {
      ...updatedSpecList[specIndex],
      [selector]: value,
      error: value ? "" : updatedSpecList[specIndex]?.error,
    };

    // Update the specList array within the updatedProduct
    updatedProduct.specList = updatedSpecList;

    // // Updating specErrorCount
    // let errorCount = Number(updatedProduct.specErrorCount)
    // if(value){
    //   errorCount = errorCount - 1
    //   updatedProduct.specErrorCount = errorCount
    //   console.log("SpecListData___ERR_COUNT", errorCount);
    // }

    // Update the product within the newProductList
    newProductList[rootIndex] = updatedProduct;

    console.log("SpecListData___handleChange_newProductList", newProductList);

    setVariantData(newProductList);
  };

  // Get Unit of measurement
  const getUnitsData = async () => {
    const response = await getUnitOfMeasurementApi();
    setUnitOfMeasurementData(() => response?.details || []);
    console.log("getUnitsData:", response);
  };

  // Fetching product details
  const getProductDetails = async () => {
    const productId = location?.state?.productId;
    const isPendingProduct = location?.state?.isPendingProduct || false;

    const businessId = sessionStorage.getItem("selectedBusinessId");

    if (isPendingProduct) {
      const data = await getReviewProductDetailsAPI({ businessId, productId });
      if (data?.details) {
        setProductDetails(data?.details);
      }
    } else {
      const data = await getViewProductDetailsAPI(productId);
      if (data?.product) {
        setProductDetails(data?.product);
      }
    }
  };

  const autoFillProductDetails = (productDetails, countryList) => {
    const refLinks =
      productDetails?.refLink?.length > 0
        ? productDetails?.refLink
        : [{ code: "", link: "" }];

    const ondc = productDetails?.ondc;

    const unitSymbol =
      ondc?.timeToShip?.charAt(ondc?.timeToShip?.length - 1) || "";

    autoFillCategotyInfo(productDetails);
    autoFillProductCodeAndVariant(productDetails);

    setProductInfo({
      copiedProductName: productDetails?.productName || "",
      productName: "",
      brand: productDetails?.brand || "",
      description: "",
      country: getSelectedCountryByCode(productDetails?.origin, countryList),
      gstPercentage: productDetails?.gstInfo?.gstPercentage || "",
      refLinks,
    });

    setOndcData({
      ...ONDC_DEFAULT_NEW_DATA,
      timeToShipUnit: getTimeToShipUnitValue(unitSymbol),
      available_on_cod: ondc?.available_on_cod,
      fragile: ondc?.fragile == true,
      timeToShip: getTimeToShipValue(unitSymbol, ondc?.timeToShip),

      cancelTerms: {
        cancellable: ondc?.cancelTerms?.cancellable || "none",
        cancellationFeeAmount: null,
        cancellationFeePercentage:
          ondc?.cancelTerms?.cancellationFeePercentage || "",
        refundEligible: ondc?.cancelTerms?.refundEligible || "none",
      },

      returnTerms: {
        returnable: ondc?.returnTerms?.returnable || "none",
        returnPeriod: ondc?.returnTerms?.returnPeriod
          ? ondc?.returnTerms?.returnPeriod?.slice(1, -1)
          : "",
        seller_pickup_return: ondc?.returnTerms?.seller_pickup_return || "none",
      },

      productCode: {
        key: ondc?.productCode?.key,
        value: ondc?.productCode?.value || "",
      },

      unitOfMeasure: productDetails?.productDisplayUnitOfMeasure,
    });

    // setSelectedVariant(variants);
  };

  const autoFillCategotyInfo = (productDetails) => {
    if (activeBusinessInfo && productDetails) {
      const businessCat = productDetails?.productMainCategory?.[0] || null;

      const productCat = productDetails?.productSubCategory?.[0] || null;
      const prodSubCat = productDetails?.productSubCategory2?.[0] || null;

      const ondcMainCat = productDetails?.productMainCategory?.[0] || null;
      const ondcSubCat = productDetails?.productSubCategory?.[0] || null;

      dispatch(getProductSubCategoryOne(businessCat?.code));
      dispatch(
        getProductSubCategoryTwo({
          pcCode: productCat?.pcCode,
          pscCode1: productCat?.pscCode1,
        })
      );

      const catData = {
        ...categoryInfo,
        ondcEnabled: productDetails?.ondcEnabled || "no",
        businessCategory: activeBusinessInfo?.businessCategories || [],
        productCategory: productDetails?.productSubCategory || [],
        productSubCategory: productDetails?.productSubCategory2 || [],

        selectedBusinessCat: {
          code: businessCat?.code || "",
          name: businessCat?.value || "",
          status: "active",
        },
        selectedProductCat: {
          code: productCat?.code || "",
          value: productCat?.value || "",
          pcCode: productCat?.pcCode || "",
          status: "active",
          pscCode1: productCat?.pscCode1 || "",
        },
        selectedProductSubCat: {
          code: prodSubCat?.code || "",
          value: prodSubCat?.value || "",
          pcCode: prodSubCat?.pcCode || "",
          psCode: prodSubCat?.psCode || "",
          status: "active",
          pscCode2: prodSubCat?.pscCode2 || "",
        },
        selectedOndcCat: {
          code: ondcMainCat?.ondcCode || "",
          name: ondcMainCat?.ondcValue || "",
          status: "active",
        },
        selectedOndcSubCat: {
          pcCode: "",
          scCode1: ondcSubCat?.ondcSubCode || "",
          pscCode1: "",
          productSubCategory1: ondcSubCat?.ondcSubValue || "",
        },
      };

      setCategoryInfo(catData);
    }
  };

  const autoFillProductCodeAndVariant = async (productDetails) => {
    const masterProductVariantId = location?.state?.productId;
    const businessId = sessionStorage.getItem("selectedBusinessId");
    const isPendingProduct = location?.state?.isPendingProduct || false;

    const ondcMainCat = productDetails?.productMainCategory?.[0] || null;

    const productCodeResponse = await getProductCodeAPI({
      domainCode: ondcMainCat?.ondcCode,
      status: "active",
    });

    if (productCodeResponse?.details?.length > 0) {
      setProductCodeList(productCodeResponse?.details);
    } else {
      setProductCodeList(PRODUCT_CODE_DEFAULT_LIST);
    }

    const specificationPayload = {
      pscCode1: `${productDetails?.productMainCategory?.[0]?.ondcCode}${productDetails?.productSubCategory?.[0]?.ondcSubCode}`,
      status: "active",
    };
    const fullSpecificationPayload = {
      domainCode: productDetails?.productMainCategory?.[0]?.ondcCode,
      status: "active",
    };

    const specification = await getOndcSpecificationAPI(specificationPayload);
    const fullSpecification = await getOndcFullSpecificationAPI(
      fullSpecificationPayload
    );
    const mapByCode = fullSpecification?.details?.reduce((acc, obj) => {
      acc[obj.code] = obj;
      return acc;
    }, {});

    const array = specification?.details?.[0]?.attributes?.map((obj1) => {
      // Check if there is a matching object in the second array based on code
      if (mapByCode[obj1?.value]) {
        // Merge properties from the second array object to the first array object
        console.log("map", mapByCode[obj1?.value]?.type);
        if (mapByCode[obj1?.value]?.display === "N") {
          return {
            ...obj1,
            required: "o",
            ...mapByCode[obj1?.value],
            inputValue: mapByCode[obj1?.value]?.defaultValue,
          };
        }
        if (mapByCode[obj1?.value]?.type === "codeValue") {
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue: "",
            options: extractNames(mapByCode[obj1?.value]?.values),
            nameCodes: extractNameCodePairs(mapByCode[obj1?.value]?.values),
          };
        }
        if (mapByCode[obj1?.value]?.type === "radioButton") {
          // const radioOptions = mapByCode[obj1?.value]?.values?.map(
          //   (jsonString) => JSON.parse(jsonString)
          // );
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            radioOptions: mapByCode[obj1?.value]?.radioOptions,
            // radioOptions: radioOptions,
          };
        }

        if (mapByCode[obj1?.value]?.type === "dependentCode") {
          return {
            ...obj1,
            required: obj1?.code,
            ...mapByCode[obj1?.value],
            inputValue: "",
            options: getOptionsForDependentCode(
              mapByCode[obj1?.value]?.dependentValues
              // subCatData?.pscCode1
            ),
          };
        }
        return {
          ...obj1,
          required: obj1?.code,
          ...mapByCode[obj1?.value],
          inputValue:
            mapByCode[obj1?.value]?.type === "default"
              ? mapByCode[obj1?.value]?.values?.[0]
              : "",
        };
      } else {
        return obj1;
      }
    });

    const filteredArray = array?.filter(
      (item) => item?.dbObjectName || item?.displayName || item?.required
    );

    setOndcSpecificationData(filteredArray);

    let childVariants = null;

    if (isPendingProduct) {
      const status = "new,updated,active";
      childVariants = await getReviewChildProductDetailsAPI(
        masterProductVariantId,
        businessId,
        status
      );
    } else {
      childVariants = await getViewChildProductDetailsAPI(
        masterProductVariantId,
        businessId
      );
    }

    const childVariantsData = prepareCopyChildVariantProductData({
      childVariants: childVariants?.details,
      specification,
      fullSpecification,
      sVariants: productDetails?.variantInfo?.variants,
      unitOfMeasurementData,
    });

    console.log("childVariants Data", childVariantsData);
    setVariantData(childVariantsData?.variantData);
    setTableHeader1(childVariantsData?.tableHeader1);
    setTableHeader2(childVariantsData?.tableHeader2);
    setSelectedVariant(childVariantsData?.selectedVariant);
  };

  const onAddRowClick = () => {
    setVariantData((prevState) => [
      ...prevState,
      getDefaultProductDetailsTable(
        selectedVariant,
        ondcSpecificationData,
        productInfo?.description,
        productInfo?.gstPercentage,
        ondcData?.productCode
      ),
    ]);
  };
  const onCopyClick = async (data) => {
    setVariantData((prevState) => [
      ...prevState,
      {
        ...data,
        main: false,
        addPhotos: [],
        deletePhotos: [],
        productId: "",
        photos: [],
      },
    ]);
  };

  const onDeleteClick = (index) => {
    let array = [...variantData];
    if (index > -1) {
      array.splice(index, 1);
    }
    setVariantData(array);
  };
  const onNextClick = () => {
    setPageError("");
    if (tab === "product-details") validateTabOne();
    if (tab === "ondc-details") validateTabTwo();
    if (tab === "product-variant") validateTabThree();
    if (tab === "ondc-variant") validateTabFour();
    if (tab === "preview") handleSubmit();
  };
  const onBackClick = () => {
    // if (tab === "ondc-details") setTab("product-details");
    if (tab === "product-variant") setTab("product-details");
    // if (tab === "ondc-variant") setTab("product-variant");
    if (tab === "preview") setTab("product-variant");

    window.scrollTo(0, 0);
  };

  const handleMainCatChange = (value) => {
    setIsCatalogChangeFlag(true);
    if (!categoryInfo?.selectedBusinessCat?.code) {
      const selectedMainCat = {
        code: value?.code,
        name: value?.name,
        status: "active",
      };

      dispatch(getProductSubCategoryOne(value?.code));
      setCategoryInfo((prevState) => ({
        ...categoryInfo,
        selectedBusinessCat: selectedMainCat,
        selectedProductCat: null,
        selectedProductSubCat: null,
        errors: prevState?.errors
          ? { ...prevState?.errors, selectedBusinessCat: "" }
          : null,
      }));
      return;
    }

    if (categoryInfo?.selectedBusinessCat?.code !== value?.code) {
      const selectedMainCat = {
        code: value?.code,
        name: value?.name,
        status: "active",
      };

      dispatch(getProductSubCategoryOne(value?.code));
      setCategoryInfo((prevState) => ({
        ...categoryInfo,
        selectedBusinessCat: selectedMainCat,
        selectedProductCat: null,
        selectedProductSubCat: null,
        errors: prevState?.errors
          ? { ...prevState?.errors, selectedBusinessCat: "" }
          : null,
      }));
    }

    // onCategoryValueChange("selectedBusinessCat", value);
  };

  const handleProductCatChange = async (value) => {
    setIsCatalogChangeFlag(true);
    dispatch(
      getProductSubCategoryTwo({
        pcCode: value?.pcCode,
        pscCode1: value?.scCode1,
      })
    );

    setCategoryInfo((prevState) => ({
      ...categoryInfo,
      selectedProductCat: {
        code: value?.pscCode1,
        value: value?.productSubCategory1,
        pcCode: value?.pcCode,
        status: "active",
        pscCode1: value?.scCode1,
      },
      selectedProductSubCat: "",
      errors: prevState?.errors
        ? { ...prevState?.errors, selectedProductCat: "" }
        : null,
    }));
  };

  const handleSubProductCatChange = (value) => {
    setIsCatalogChangeFlag(true);
    setCategoryInfo({
      ...categoryInfo,
      selectedProductSubCat: {
        code: value?.pscCode2,
        value: value?.productSubCategory2,
        pcCode: value?.pcCode,
        psCode: value?.pcCode + value?.scCode1,
        status: "active",
        pscCode2: "",
      },
    });
  };

  const validateTabOne = () => {
    let productInfoErr = null;
    let categoryErr = null;
    let ondcErrors = null;

    console.log("TAB_1_DATA", productInfo, categoryInfo);

    // categories
    if (!categoryInfo?.selectedBusinessCat) {
      categoryErr = {
        ...categoryErr,
        selectedBusinessCat: "Select business category",
      };
    }
    if (!categoryInfo?.selectedProductCat) {
      categoryErr = {
        ...categoryErr,
        selectedProductCat: "Select product category",
      };
    }

    // Product Info
    if (!productInfo?.productName) {
      productInfoErr = { ...productInfoErr, productName: "Enter product name" };
    }
    if (!productInfo?.country) {
      productInfoErr = { ...productInfoErr, country: "Select origin" };
    }
    if (!productInfo?.gstPercentage) {
      productInfoErr = {
        ...productInfoErr,
        gstPercentage: "Select GST percentage",
      };
    }
    if (!productInfo?.description) {
      productInfoErr = { ...productInfoErr, description: "Enter description" };
    }

    // Reference Link
    const isRefLinkError = productInfo?.refLinks?.some(
      (item) =>
        (item?.code === "" && item?.link !== "") ||
        (item?.code !== "" && item?.link === "")
    );

    if (isRefLinkError) {
      productInfoErr = {
        ...productInfoErr,
        refLinks: "Enter the label and value",
      };
    }

    // Ondc Info
    if (!ondcData?.timeToShip || ondcData?.timeToShip == "0") {
      ondcErrors = { ...ondcErrors, timeToShip: "Enter time to ship" };
    }

    if (
      !ondcData?.returnTerms?.returnPeriod ||
      ondcData?.returnTerms?.returnPeriod == "0"
    ) {
      ondcErrors = { ...ondcErrors, returnPeriod: "Enter return period" };
    }

    if (ondcData?.cancelTerms?.cancellable?.toLowerCase() === "yes") {
      if (!ondcData?.cancelTerms?.cancellationFeePercentage) {
        ondcErrors = {
          ...ondcErrors,
          cancellationFeePercentage: "Enter cancellation fee percentage",
        };
      }
      if (
        ondcData?.cancelTerms?.cancellationFeePercentage > 0 &&
        ondcData?.cancelTerms?.cancellationFeePercentage > 100
      ) {
        ondcErrors = {
          ...ondcErrors,
          cancellationFeePercentage:
            "Cancellation fee percentage should be less than or equal to 100",
        };
      }
    }

    if (!ondcData?.productCode?.key) {
      ondcErrors = { ...ondcErrors, productCode1: "Select product code" };
    }

    if (!ondcData?.productCode?.value) {
      ondcErrors = { ...ondcErrors, productCode: "Enter product code" };
    }

    if (ondcData?.productCode?.key && ondcData?.productCode?.value) {
      const productCodeLookup = productCodeList?.find(
        (obj) => obj?.prodictCode === ondcData?.productCode?.key
      );

      let pcError = true;
      productCodeLookup?.validation?.forEach((pattern) => {
        const regex = new RegExp(
          pattern?.replace(/d/g, "\\d")?.replace(/\./g, "\\.")
        );
        if (regex.test(ondcData?.productCode?.value)) {
          pcError = false;
        }
      });

      if (pcError) {
        ondcErrors = {
          ...ondcErrors,
          productCode: `Enter valid ${getProductCodeLength(
            productCodeList,
            ondcData?.productCode?.key
          )} digit product code`,
        };
      }
    }

    if (
      selectedVariant?.variant1?.value?.code !== "uom" &&
      selectedVariant?.variant2?.value?.code !== "uom"
    ) {
      if (!ondcData?.unitOfMeasure?.unit) {
        ondcErrors = {
          ...ondcErrors,
          unitOfMeasure1: "Select Unit of measure",
        };
      }

      if (!ondcData?.unitOfMeasure?.value) {
        ondcErrors = { ...ondcErrors, unitOfMeasure: "Enter Unit of measure" };
      }
    }

    if (productInfoErr || categoryErr || ondcErrors) {
      if (categoryErr) {
        setCategoryInfo((prevState) => ({
          ...prevState,
          errors: categoryErr,
        }));
      }
      if (productInfoErr) {
        setProductInfo((prevState) => ({
          ...prevState,
          errors: productInfoErr,
        }));
      }
      if (ondcErrors) {
        handleSetValue("errors", ondcErrors, ondcData, setOndcData);
      }
    } else {
      setCategoryInfo((prevState) => ({
        ...prevState,
        errors: null,
      }));

      setProductInfo((prevState) => ({
        ...prevState,
        errors: null,
      }));

      handleSetValue("errors", ondcErrors, ondcData, setOndcData);

      const updatedVariants = variantData?.map((item) => ({
        ...item,
        description: productInfo?.description || "",
      }));

      setVariantData(updatedVariants);

      setTab("product-variant");
      window.scrollTo(0, 0);
    }
  };

  const validateTabTwo = () => {
    let ondcErrors = null;
    let pageError = null;

    if (!ondcData?.timeToShip || ondcData?.timeToShip == "0") {
      ondcErrors = { ...ondcErrors, timeToShip: "Enter time to ship" };
    }

    if (
      !ondcData?.returnTerms?.returnPeriod ||
      ondcData?.returnTerms?.returnPeriod == "0"
    ) {
      ondcErrors = { ...ondcErrors, returnPeriod: "Enter return period" };
    }

    if (ondcData?.cancelTerms?.cancellable?.toLowerCase() === "yes") {
      if (!ondcData?.cancelTerms?.cancellationFeePercentage) {
        ondcErrors = {
          ...ondcErrors,
          cancellationFeePercentage: "Enter cancellation fee percentage",
        };
      }
      if (
        ondcData?.cancelTerms?.cancellationFeePercentage > 0 &&
        ondcData?.cancelTerms?.cancellationFeePercentage > 100
      ) {
        ondcErrors = {
          ...ondcErrors,
          cancellationFeePercentage:
            "Cancellation fee percentage should be less than or equal to 100",
        };
      }
    }

    if (!ondcData?.productCode?.key) {
      ondcErrors = { ...ondcErrors, productCode1: "Select product code" };
    }

    if (!ondcData?.productCode?.value) {
      ondcErrors = { ...ondcErrors, productCode: "Enter product code" };
    }

    if (ondcData?.productCode?.key && ondcData?.productCode?.value) {
      const productCodeLookup = productCodeList?.find(
        (obj) => obj?.prodictCode === ondcData?.productCode?.key
      );

      let pcError = true;
      productCodeLookup?.validation?.forEach((pattern) => {
        const regex = new RegExp(
          pattern?.replace(/d/g, "\\d")?.replace(/\./g, "\\.")
        );
        if (regex.test(ondcData?.productCode?.value)) {
          pcError = false;
        }
      });

      if (pcError) {
        ondcErrors = {
          ...ondcErrors,
          productCode: `Enter valid ${getProductCodeLength(
            productCodeList,
            ondcData?.productCode?.key
          )} digit product code`,
        };
      }
    }

    if (
      selectedVariant?.variant1?.value?.code !== "uom" &&
      selectedVariant?.variant2?.value?.code !== "uom"
    ) {
      if (!ondcData?.unitOfMeasure?.unit) {
        ondcErrors = {
          ...ondcErrors,
          unitOfMeasure1: "Select Unit of measure",
        };
      }

      if (!ondcData?.unitOfMeasure?.value) {
        ondcErrors = { ...ondcErrors, unitOfMeasure: "Enter Unit of measure" };
      }
    }

    console.log("TAB_TWO_ERRORS", ondcErrors);

    handleSetValue("errors", ondcErrors, ondcData, setOndcData);
    if (ondcErrors) {
      return;
    }

    const updatedVariants = variantData?.map((item) => ({
      ...item,
      description: productInfo?.description || "",
    }));

    setVariantData(updatedVariants);

    setTab("product-variant");
    window.scrollTo(0, 0);
  };

  const validateTabThree = () => {
    let isError = false;

    if (variantData?.length === 0) {
      setPageError("Add the Variants");
      return;
    }

    const validateProduct = validateEditProductDetails(
      variantData,
      productCodeList
    );

    const validateOndcProduct = validateOndcSpecs(variantData);

    console.log("VALIDATE_PRODUCT", validateProduct);

    if (variantData?.every((obj) => obj?.main === false)) {
      setPageError("Select a main variant");
      isError = true;
    }

    if (validateProduct?.isError || validateOndcProduct?.isError) {
      // let row = "";
      // validateProduct?.allVariants?.forEach((item, index) => {
      //   if (item?.errors)
      //     row = index == 0 ? row + (index + 1) : row + ` ,${index + 1}`;
      // });

      const mergedArray = mergeValidatedArrays(
        validateProduct?.allVariants,
        validateOndcProduct?.allVariants
      );
      setVariantData(mergedArray);
      // setPageError(`Errors in ${row} variant row`);
      isError = true;
    }

    if (isError) return;

    const data = prepareEditPreviewVariantData(ondcData);

    setOndcPreviewData(data);

    setTab("preview");
    window.scrollTo(0, 0);
  };

  const validateTabFour = () => {
    if (variantData?.length === 0) {
      setPageError("Add the Variants in previous page");
      return;
    }

    const validateProduct = validateOndcSpecs(variantData);

    setVariantData(validateProduct?.allVariants);
    if (validateProduct?.isError) return;

    const data = prepareEditPreviewVariantData(ondcData);

    setOndcPreviewData(data);

    setTab("preview");
    window.scrollTo(0, 0);
  };

  const handleSubmit = async () => {
    const businessId = sessionStorage.getItem("selectedBusinessId");

    setShowAlert(false);

    const mainPayload = prepareMainVariant({
      productInfo,
      selectedVariant,
      categoryInfo,
      ondcInfo: ondcData,
      businessInfo: activeBusinessInfo,
    });

    console.log("mainPayload", mainPayload);

    setLoader(true);

    const mainRes = await addNewProductVariantApi({
      businessId,
      data: mainPayload,
    });

    if (mainRes) {
      const id = mainRes?.productID;

      let childVariantPayload = [];

      variantData?.forEach((variant, index) => {
        const variantPayLoad = prepareVariantData({
          productInfo,
          selectedVariant,
          categoryInfo,
          ondcInfo: ondcData,
          businessInfo: activeBusinessInfo,
          id,
          index,
          variant,
        });
        console.log(`Variant_Payload ${index + 1}`, variantPayLoad);

        childVariantPayload.push(variantPayLoad);

        // const variantRes = await addNewProductVariantApi({
        //   businessId,
        //   data: variantPayLoad,
        // });
        // console.log(`Variant_Response ${index + 1}`, variantRes);
      });

      const childRes = await addNewProductChildVariantApi({
        businessId,
        data: childVariantPayload,
      });
    }

    setShowAlert(true);
    dispatch(clearCatalogData());
    setLoader(false);
  };

  const handleCancel = () => {
    const webURL = sessionStorage.getItem("costboWEBURL");

    const url = `/${webURL}/catalog`;
    navigate(url);
  };

  useEffect(() => {
    if (
      productDetails &&
      countryList?.length > 0 &&
      unitOfMeasurementData?.length > 0
    ) {
      autoFillProductDetails(productDetails, countryList);
    }
    return () => {};
  }, [productDetails, countryList, unitOfMeasurementData]);

  useEffect(() => {
    getProductDetails();
    if (unitOfMeasurementData?.length === 0) {
      getUnitsData();
    }
    return () => {};
  }, []);

  return activeBusinessInfoLoader ||
    !productDetails ||
    !categoryInfo ||
    !variantData ? (
    <ThreeDotLoader />
  ) : (
    <Box>
      <Box
        sx={{
          ...stickyHeader,
          display: { md: "block", xs: "none" },
          pb: 1,
          mb: 1,
        }}
      >
        <BreadcrumbSection links={links} />
        <Typography
          component="h6"
          fontSize={{ xs: 15, md: 17 }}
          color={blackColor}
          fontWeight={{ xs: 600, md: 600 }}
          lineHeight="20px"
          display="inline"
        >
          Product Variant details copied from -{" "}
          <span style={{ color: blueColor04 }}>
            {productInfo?.copiedProductName}
          </span>
        </Typography>
      </Box>

      <CategoryPreview
        productName={productInfo?.productName}
        hideProductName={tab === "product-details"}
        categoryData={categoryInfo}
        selectedVariant={selectedVariant}
        hideWebCategory={tab === "product-details"}
      />

      {tab === "product-details" && (
        <>
          <OndcCategoryForm
            data={categoryInfo}
            setData={setCategoryInfo}
            hideOndcCat
            handleMainCatChange={handleMainCatChange}
            handleProductCatChange={handleProductCatChange}
            handleSubProductCatChange={handleSubProductCatChange}
            // handleOndcCategoryChange={handleOndcCategoryChange}
            // handleOndcSubCategoryChange={handleOndcSubCategoryChange}
          />
          <ProductDetailsForm
            data={productInfo}
            onValueChange={(name, value) =>
              handleSetValue(name, value, productInfo, setProductInfo)
            }
          />

          <CommonOndcForm
            ondcData={ondcData}
            selectedVariant={selectedVariant}
            unitOfMeasurementData={unitOfMeasurementData}
            productCodeList={productCodeList}
            onValueChange={(name, value) =>
              handleSetValue(name, value, ondcData, setOndcData)
            }
            handleKeyValueChange={handleKeyValueChange}
          />
        </>
      )}
      {tab === "ondc-details" && (
        <CommonOndcForm
          ondcData={ondcData}
          selectedVariant={selectedVariant}
          unitOfMeasurementData={unitOfMeasurementData}
          productCodeList={productCodeList}
          onValueChange={(name, value) =>
            handleSetValue(name, value, ondcData, setOndcData)
          }
          handleKeyValueChange={handleKeyValueChange}
        />
      )}
      {tab === "product-variant" && (
        <>
          <ProductVariantForm
            tableHeader={tableHeader1}
            variantData={variantData}
            handleAddRow={onAddRowClick}
            onCopyClick={onCopyClick}
            onDeleteClick={onDeleteClick}
            handleValueChange={handleValueChange}
            onDeletePhotos={(key, index) => handleValueChange(key, "", index)}
            productCodeList={productCodeList}
          />
          <VariantOndcForm
            tableHeader={tableHeader2}
            variantData={variantData}
            handleChange={handleOndcSpecChange}
            onDeleteClick={onDeleteClick}
          />
        </>
      )}
      {tab === "ondc-variant" && (
        <VariantOndcForm
          tableHeader={tableHeader2}
          variantData={variantData}
          handleChange={handleOndcSpecChange}
          onDeleteClick={onDeleteClick}
        />
      )}
      {tab === "preview" && (
        <ProductPreviewTab
          productInfo={productInfo}
          ondcDetails={ondcPreviewData}
          tableHeader1={tableHeader1?.slice(0, -1)}
          tableHeader2={tableHeader2?.slice(0, -1)}
          variantData={variantData}
        />
      )}

      <Box>
        <CatalogActionBtns
          hideSaveBtn
          showBackBtn={tab !== "product-details"}
          onNextClick={onNextClick}
          onBackClick={onBackClick}
          nextBtnText={
            tab === "preview"
              ? "Submit"
              : tab === "product-variant"
              ? "Preview & submit"
              : "Next"
          }
          isLoading={loader}
          onCancelClick={handleCancel}
        />
        {pageError ? (
          <Typography
            fontSize={12}
            fontWeight={500}
            mt={1}
            textAlign="right"
            color={"red"}
          >
            {pageError}
          </Typography>
        ) : null}
      </Box>

      <ModalCard
        open={showAlert}
        handleClose={() => {
          // setShowAlert(false);
        }}
        width="48%"
      >
        <AlertPopup
          // isLoading={addProductLoader}
          text={`Product Variant copied successfully. Our team will review and approve within 24 hours.  New products will be available for customer ordering after approval.\nFor immediate approval, please contact via whatsapp - ‘8088422615’`}
          onClick={() => {
            const webURL = sessionStorage.getItem("costboWEBURL");
            navigate(`/${webURL}/catalogPending`);
            setShowAlert(false);
          }}
          btnTxt="Go To Catalog"
        />
      </ModalCard>
    </Box>
  );
}

export default CopyVariantProductContent;
